<template>
  <div>
    <div class="colspan" id="donationRC">
      <h4>捐赠公示</h4>
      <div class="content">
        <div class="title">
          <div>项目名称</div>
          <div>捐款人单位</div>
          <div>捐款人姓名</div>
          <div>捐款金额</div>
          <div>捐赠时间</div>
        </div>
        <ul>
          <li v-for="item in infoList" :key="'aa'+item.id">
            <div :title="item.project_name">{{item.project_name}}</div>
            <div :title="item.org_name?item.org_name:'个人'">
              <div>{{item.org_name?item.org_name:'个人'}}</div>
            </div>
            <div :title="item.pub_name||item.name">
              <div>{{item.pub_name||item.name}}</div>
            </div>
            <div>
              <div>￥{{item.money}}</div>
            </div>
            <div>{{item.created_at}}</div>
          </li>
        </ul>
      </div>
      <div class="page">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          layout="prev, pager, next"
          :page-size="page_size"
          :total="total"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      infoList: [],
      title: "",
      page: 1,
      page_size: 10,
      total: 0,
      cate_id: null,
      id: null, //导航id
      // cate_id: [] ,//分类ID
      second_navId: null //二级导航
    };
  },
  methods: {
    prev() {
      
    },

    //点击下一页和点击页码时执行
    handleCurrentChange(val) {
      this.getPageData();
    },

    getPageData() {
      let that = this;
      this.$db
        .get(
          this.$url.donation.list +
            "?page=" +
            this.page +
            "&page_size=" +
            this.page_size
        )
        .then(res => {
          that.infoList = res.data.data;
          that.total = res.data.total;
        }).catch(err => {
            console.log(err);
          });
    }
  },
  created() {
    this.id = this.$route.query.id;
    this.getPageData();
    let that = this;
    that.$db.get(this.$url.channel.url + "/" + this.id).then(res => {
      that.title = res.data.title;
    }).catch(err => {
            console.log(err);
          });
  },
  watch: {
    "$route.query.id": function(value) {
      if (value) {
        this.id = value;
        this.page = 1;
        this.getPageData();
      }
    },
    "$route.query.second_navId": function(value) {
      if (value) {
        this.second_navId = value;
        this.page = 1;
        this.getPageData();
      } else if (typeof value == "undefined") {
        // this.getPageData(this.id);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.colspan {
  min-height: 754px;
  overflow: hidden;
  background-color: #ffffff;
  box-sizing: border-box;
  position: relative;
  background: url("../../assets/images/taoyuan/page_bg.jpg") repeat-x;
  > h4 {
    background: url("../../assets/images/taoyuan/subpage_lm_icon.gif") left
      center no-repeat;
    padding-left: 20px;
    height: 24px;
    line-height: 24px;
    font-size: 22px;
    color: #d10000;
    margin: 30px 0 20px 30px;
  }
  > .top {
    > i {
      width: 104px;
      height: 2px;
      position: absolute;
      left: 12px;
      top: 0;
    }
    > .p1 {
      float: left;
      padding-left: 12px;
      font-size: 20px;
      margin-bottom: 0;
    }
  }
  > .content {
    min-height: 550px;
    .title {
      display: flex;
      justify-content: space-between;
      margin: 30px 30px 0;
      box-sizing: border-box;
      height: 49px;
      line-height: 50px;
      color: #404040;
      border-bottom: 1px dashed #ccc;
      > div:nth-of-type(1) {
        width: 25%;
      }
      > div:nth-of-type(2) {
        width: 25%;
      }
      > div:nth-of-type(3) {
        width: 20%;
      }
      > div:nth-of-type(4) {
        width: 20%;
      }
      > div:nth-of-type(5) {
        width: 10%;
      }
    }
    > ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      > li {
        display: flex;
        justify-content: space-between;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px dashed #ccc;
        color: #404040;
        font-size: 14px;
        margin: 0 30px;
        box-sizing: border-box;
        > div {
          margin: 0;
          width: 25%;
          font-size: 16px;
          color: #404040;
          overflow: hidden;
          text-overflow: ellipsis; //超出部分以省略号显示
          white-space: nowrap;
        }
        > div:nth-of-type(1) {
          width: 25%;
        }
        > div:nth-of-type(2) {
          width: 25%;
          > div {
            padding-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis; //超出部分以省略号显示
            white-space: nowrap;
          }
        }
        > div:nth-of-type(3) {
          width: 20%;
          > div {
            padding-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis; //超出部分以省略号显示
            white-space: nowrap;
          }
        }
        > div:nth-of-type(4) {
          width: 20%;
          > div {
            padding-right: 10px;
            overflow: hidden;
            text-overflow: ellipsis; //超出部分以省略号显示
            white-space: nowrap;
          }
        }
        > div:nth-of-type(5) {
          color: #888;
          width: 10%;
        }
      }
      > li:nth-last-child(1) {
        border-bottom: none;
      }
    }
  }
  > .page {
    float: left;
    overflow: hidden;
    margin-left: 50%;
    margin-top: 20px;
    height: 100px;
    line-height: 100px;
    transform: translateX(-50%);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/donation/list2.vue